import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  InstallationDetailsStore,
  RefrigerationCircuitMessagesActions,
  RefrigerationCircuitMessagesSelectors,
} from '@store';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RefrigerationCircuitMessagesStore {
  loading$ = this.store.select(RefrigerationCircuitMessagesSelectors.getLoadingIndicator);

  refrigerationCircuitMessages$ = this.installationDetailsStore.gatewaySerial$.pipe(
    switchMap((serial) =>
      this.store.select(
        RefrigerationCircuitMessagesSelectors.getRefrigerationCircuitMessages(serial)
      )
    )
  );

  constructor(private store: Store, private installationDetailsStore: InstallationDetailsStore) {}

  getRefrigerationCircuitMessages(): void {
    this.store.dispatch(RefrigerationCircuitMessagesActions.getRefrigerationCircuitMessages());
  }
}
